import { atom } from "recoil";

export const resetPassModalState = atom({
  key: "resetPassModalState",
  default: false,
});